import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const socialLinks = [
    { href: 'https://www.youtube.com/@aone', id: 'youtube' },
    { href: 'https://pf.kakao.com/_pyJxcb', id: 'kakaotalk' },
    { href: 'https://blog.naver.com/aoneinstitute', id: 'naver' },
  ];

  return (
    <footer className="hidden sm:block w-full border-t border-gray-200 dark:border-gray-700 mt-auto bg-white dark:bg-gray-800 transition-colors">
      <div className="max-w-[1760px] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 py-6 sm:py-8">
        <div className="flex flex-col sm:flex-row justify-between gap-6 sm:gap-8">
          {/* Logo */}
          <div className="shrink-0">
            {/* Light mode logo */}
            <img
              src="https://d1qf1106vb1ual.cloudfront.net/static/logo.svg"
              alt="AONE INSTITUTE"
              className="h-8 sm:h-10 w-auto dark:hidden"
            />
            {/* Dark mode logo - white text with colored A */}
            <img
              src="/assets/logo-dark.svg"
              alt="AONE INSTITUTE"
              className="h-8 sm:h-10 w-auto hidden dark:block"
            />
          </div>

          {/* Contact Info + Terms + Copyright */}
          <div className="flex flex-col gap-4">
            {/* Email */}
            <a
              href="mailto:aoneinstituteoffice@gmail.com"
              className="text-[#5E9ED6] font-semibold text-sm sm:text-base underline underline-offset-4 hover:text-[#4a8bc4]"
            >
              aoneinstituteoffice@gmail.com
            </a>

            {/* Hours, Address, Tel */}
            <div className="flex flex-col gap-1 text-gray-500 dark:text-gray-400 text-xs sm:text-sm">
              <div className="flex flex-col sm:flex-row sm:gap-8">
                <div className="hidden sm:block">
                  <p className="font-medium text-gray-600 dark:text-gray-300">{t('footer.hours')}</p>
                  <p className="font-medium text-gray-600 dark:text-gray-300">{t('footer.address')}</p>
                  <p className="font-medium text-gray-600 dark:text-gray-300">{t('footer.tel')}</p>
                </div>
                <div className="flex flex-col font-light">
                  <p>{t('footer.hoursValue')}</p>
                  <a
                    href="https://maps.app.goo.gl/s6rukqMufxCzbBdn9"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-[#5E9ED6]"
                  >
                    {t('footer.addressValue')}
                  </a>
                  <p>201-266-8882 / 201-346-5689</p>
                </div>
              </div>
            </div>

            {/* Terms and Privacy */}
            <div className="flex gap-4 text-xs sm:text-sm font-light text-gray-500 dark:text-gray-400 mt-2">
              <Link to="/tos" className="hover:text-[#5E9ED6]">{t('menu.termsOfUse')}</Link>
              <Link to="/privacy" className="hover:text-[#5E9ED6]">{t('menu.privacyPolicy')}</Link>
            </div>

            {/* Copyright */}
            <p className="text-xs sm:text-sm font-light text-gray-400 dark:text-gray-500">
              {t('footer.copyright')}
            </p>
          </div>

          {/* Social Links - Vertical stack */}
          <div className="flex flex-col gap-2 text-gray-500 dark:text-gray-400 text-sm">
            {socialLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1 hover:text-[#5E9ED6] transition-colors"
              >
                <span>{t(`footer.social.${link.id}`)}</span>
                <ExternalLink className="w-3 h-3" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
